import { setInspector, setGraphInspector } from 'effector/effector.mjs';
import { is } from 'effector';
import debounce from 'just-debounce-it';
import isNode from 'detect-node';

function e(e){return c.add(e),n((()=>{c.delete(e);}))}function t(e){return s.add(e),n((()=>{s.delete(e);}))}function n(e){const t=()=>e();return t.unsubscribe=t,t}function i(e){return d(e.node)}function d(e){const{meta:t,id:n}=e,i=(e=>e.config?e.config.loc:e.loc)(t),{sid:d,name:o,op:r}=t;return {meta:t,id:n,sid:d,name:o,kind:r,loc:i,derived:t.derived}}function o(e){if(!e)return;const{parent:t,meta:n,id:i}=e,d=o(t)||void 0;if('factory'===n.type){const{sid:e,name:t,loc:o,method:r}=n;return {type:'factory',id:i,region:d,meta:n,sid:e,name:t,loc:o,method:r}}return {type:'region',id:i,region:d,meta:n}}const c=new Set;setInspector(((e,t)=>{const{scope:n}=e,d=i(e);let o;c.forEach((r=>{r.scope!==n&&(r.scope||n)||(r.trace&&!o&&(o=(e=>{const t=[];let n=e.parent;for(;n;){const e=i(n);t.push({type:'update',value:n.value,stack:n.meta||{},meta:e.meta,id:e.id,sid:e.sid,name:e.name,kind:e.kind,loc:e.loc,derived:e.derived}),n=n.parent;}return t})(e)),r.fn({type:t.fail?'error':'update',value:e.value,error:t.fail?t.failReason:void 0,stack:e.meta||{},trace:r.trace?o:[],meta:d.meta,id:d.id,sid:d.sid,name:d.name,kind:d.kind,loc:d.loc,derived:d.derived}));}));}));const s=new Set;setGraphInspector(((e,t)=>{let n;n='region'===e?o(t):((e,t)=>{const n=d(e);return {type:'unit',region:o(t),meta:n.meta,id:n.id,sid:n.sid,name:n.name,kind:n.kind,loc:n.loc,derived:n.derived}})(e,t),n&&s.forEach((e=>{e.fn(n);}));}));

function getName(m, loggerName) {
  const finalName = m.name || locToString(m.loc) || `unknown_${m.id}`;
  if (!loggerName) return finalName;
  return `(${loggerName}) ${finalName}`;
}
function locToString(loc) {
  if (!loc) return null;
  return `${loc.file}:${loc.line}:${loc.column}`;
}
function getNode(unit) {
  return unit.graphite;
}
function getStateFromDeclaration(d, scope) {
  if (scope) {
    return HACK_readStateFromScope(d, scope);
  }

  return d.meta.defaultState;
}

function HACK_readStateFromScope(d, scope) {
  const stateRefId = d.meta.rootStateRefId;
  const scopeRef = scope.reg[stateRefId];

  if (scopeRef) {
    return scopeRef.current;
  }

  if (stateRefId in scope.values.idMap) {
    return {
      value: scope.values.idMap[stateRefId]
    };
  }

  const sid = d.meta.sid;

  if (sid && sid in scope.values.sidMap) {
    return scope.values.sidMap[sid];
  }

  return d.meta.defaultState;
}

const SEPARATOR = isNode ? '  ' : '';
const storeListToInit = [];
const eventListToInit = [];
const effectListToInit = [];
t({
  fn: d => {
    if (!d.derived) {
      if (d.kind === 'store' && !d.meta.named) {
        storeListToInit.push(d);
      }

      if (d.kind === 'event' && !d.meta.named) {
        eventListToInit.push(d);
      }

      if (d.kind === 'effect' && !d.meta.named) {
        effectListToInit.push(d);
      }
    }
  }
});
const styles = {
  block: 'padding-left: 4px; padding-right: 4px; font-weight: normal;',
  chunk: 'padding-left: 4px; padding-right: 4px; font-weight: normal;',
  effector: 'line-height:1.5; color: #000; font-family: "Apple Emoji Font"; font-weight: normal !important;',
  new: 'background-color: #29b6f6; color: #000',
  store: 'background-color: #7e57c2; color: #fff',
  event: 'background-color: #9ccc65; color: #000',
  effect: 'background-color: #26a69a; color: #000',
  emoji: '',
  file: 'color: #9e9e9e; padding-left: 20px;',
  reset: 'color: currentColor; background-color: transparent;'
};
const effectorLabel = [['☄️', '%s', styles.effector], ['effector', '%s', 'font-family: Menlo, monospace;']];

const reset = (index, count, style) => index === count - 1 ? styles.reset : style;

function log$1(blocks, chunks, group = undefined) {
  const str = [];
  const params = [];
  blocks.unshift(...effectorLabel);
  blocks.forEach(([value, view, style], index) => {
    str.push(`%c${view}%c`);
    params.push(`${styles.block} ${style}`, value, reset(index, blocks.length, `${styles.block} ${style}`));
  });
  chunks.forEach(([value, view, style]) => {
    str.push(`%c${view}`);
    params.push(`${styles.chunk} ${style}`, value);
  });
  const args = [str.join(SEPARATOR), ...params];

  if (group === 'open') {
    console.group(...args);
  } else if (group === 'collapsed') {
    console.groupCollapsed(...args);
  } else {
    console.log(...args);
  }
}

const blockNew = ['new', '%s', styles.new];

const stripDomain = name => name.split('/').pop() || name;

const createBlockStore = name => [stripDomain(name), '%s', styles.store];

const createBlockEvent = name => [stripDomain(name), '%s', styles.event];

const createBlockEffect = name => [stripDomain(name), '%s', styles.effect];

const createDeclarationsLogger = config => debounce(() => {
  const stores = storeListToInit.splice(0, storeListToInit.length);
  const events = eventListToInit.splice(0, eventListToInit.length);
  const effects = effectListToInit.splice(0, effectListToInit.length);

  if (stores.length + events.length + effects.length > 0) {
    log$1([blockNew], [['Initialized', '%s', ''], [`events(${events.length})`, '%s', ''], [`effects(${effects.length})`, '%s', ''], [`stores(${stores.length})`, '%s', '']], 'collapsed');

    if (stores.length) {
      stores.forEach(store => {
        const name = getName(store, config.name);
        const fileName = locToString(store.loc);
        log$1([blockNew, createBlockStore(name)], [['-> ', '%s', ''], [getStateFromDeclaration(store, config.scope), '%o', ''], [fileName, '%s', styles.file], [name, '%s', '']]);
      });
    }

    if (events.length > 0) {
      events.forEach(event => {
        const name = getName(event, config.name);
        const fileName = locToString(event.loc);
        log$1([blockNew, createBlockEvent(name)], [[fileName, '%s', styles.file], [name, '%s', '']]);
      });
    }

    if (effects.length > 0) {
      effects.forEach(effect => {
        const name = getName(effect, config.name);
        const fileName = locToString(effect.loc);
        log$1([blockNew, createBlockEffect(name)], [[fileName, '%s', styles.file], [name, '%s', '']]);
      });
    }

    console.groupEnd();
  }
}, 5);
function storeUpdated(name, fileName, value) {
  log$1([createBlockStore(name)], [['-> ', '%s', ''], [value, '%o', ''], [fileName, '%s', styles.file], [name, '%s', styles.file]]);
}
function eventCalled(name, fileName, payload) {
  log$1([createBlockEvent(name)], [[payload, '%o', 'padding-left: 4px;'], [fileName, '%s', styles.file], [name, '%s', styles.file]]);
}
function effectCalled(name, fileName, parameters) {
  log$1([createBlockEffect(name)], [[parameters, '%o', 'padding-left: 4px;'], [fileName, '%s', styles.file], [name, '%s', styles.file]]);
}
function effectDone(name, fileName, parameters, result) {
  log$1([createBlockEffect(name)], [['done ✅', '%s', styles.emoji], [parameters, '(%o)', 'padding-left: 4px;'], ['-> ', '%s', ''], [result, '%o', 'padding: 0;'], [fileName, '%s', styles.file], [name, '%s', styles.file]]);
}
function effectFail(name, fileName, parameters, error) {
  const instanceofError = error instanceof Error;
  log$1([createBlockEffect(name)], [['fail ❌', '%s', styles.emoji], [parameters, '(%o)', 'padding-left: 4px;'], ['-> ', '%s', ''], instanceofError ? [String(error), '%s', ''] : [error, '%o', 'padding: 0;'], [fileName, '%s', styles.file], [name, '%s', styles.file]], instanceofError ? 'collapsed' : undefined);

  if (instanceofError) {
    log$1([], [[' ', '%s', ''], [error, '%o', 'padding-left: 20px;']]);
  }

  console.groupEnd();
}

var _effectorFileName = "/src/index.ts";
const ignored = new Set();
const forceLog = new Set();
const fxRunning = new Map();
function attachLogger(config = {}) {
  const name = config.name || (config.scope ? `scope: ${getNode(config.scope).id}` : '');
  const logDeclarations = createDeclarationsLogger({
    name,
    scope: config.scope
  });
  const uninspect = e({
    scope: config.scope || undefined,
    fn: m => {
      if (
      /**
       * Log only non-derived units by default
       */
      isLoggable(m) && !ignored.has(m.id) ||
      /**
       * Log any units if they are forced to be logged
       */
      forceLog.has(m.id)) {
        log(m, name);
      }
    }
  });
  logDeclarations();
  const uninspectGraph = t({
    fn: () => {
      logDeclarations();
    }
  });
  return () => {
    uninspect();
    uninspectGraph();
  };
}
function configure(unitOrUnits, config) {
  const units = Array.isArray(unitOrUnits) ? unitOrUnits : [unitOrUnits];

  if (config.log === 'disabled') {
    units.forEach(unit => {
      ignored.add(getNode(unit).id);

      if (is.effect(unit, {
        loc: {
          file: _effectorFileName,
          line: 49,
          column: 16
        },
        sid: "-rsiho1"
      })) {
        ignored.add(getNode(unit.finally).id);
      }
    });
  }

  if (config.log === 'enabled') {
    units.forEach(unit => {
      forceLog.add(getNode(unit).id);

      if (is.effect(unit, {
        loc: {
          file: _effectorFileName,
          line: 57,
          column: 16
        },
        sid: "-e27g8e"
      })) {
        forceLog.add(getNode(unit.finally).id);
      }
    });
  }
} // utils

function isLoggable(m) {
  return isEffectFinally(m) || !m.meta.derived && m.type === 'update';
}

function isEffectFinally(m) {
  return m.kind === 'event' && m.meta.named === 'finally';
}

function log(m, name) {
  if (m.kind === 'effect') {
    const fxName = getName(m, name);
    effectCalled(fxName, locToString(m.loc) || '', m.value);
    fxRunning.set(m.stack.fxID, fxName);
    return;
  }

  if (isEffectFinally(m)) {
    const fxName = fxRunning.get(m.stack.fxID);

    if (fxName) {
      fxRunning.delete(m.stack.fxID);
      const finallyValue = m.value;

      if (finallyValue.status === 'fail') {
        effectFail(fxName, locToString(m.loc) || '', finallyValue.params, finallyValue.error);
      }

      if (finallyValue.status === 'done') {
        effectDone(fxName, locToString(m.loc) || '', finallyValue.params, finallyValue.result);
      }
    }

    return;
  }

  if (m.kind === 'store') {
    storeUpdated(getName(m, name), locToString(m.loc) || '', m.value);
    return;
  }

  if (m.kind === 'event') {
    eventCalled(getName(m, name), locToString(m.loc) || '', m.value);
    return;
  }
}

export { attachLogger, configure };
//# sourceMappingURL=index.mjs.map
